import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';

export class ToggleActions {
    public static toggleType(value: string): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.TOGGLE_VALUE,
            value: value
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/ToggleActions.ts